import { useState, useMemo, useCallback } from "react";
import { useAuth } from "../context/AuthContext";
import {
  extractUserPII,
  containsPersonalData,
} from "../utils/personalDataFilter";

export function usePersonalDataGuard() {
  const { athleteData, scoutData } = useAuth();
  const [piiWarning, setPiiWarning] = useState(null);

  const userPII = useMemo(
    () => extractUserPII(athleteData, scoutData),
    [athleteData, scoutData],
  );

  const checkMessage = useCallback(
    (message) => {
      const result = containsPersonalData(message, userPII);
      if (result.blocked) setPiiWarning(result.reason);
      return result;
    },
    [userPII],
  );

  const clearWarning = useCallback(() => setPiiWarning(null), []);

  return { piiWarning, checkMessage, clearWarning };
}
